/* HAND-AUTHORED (the artifact pipeline was unavailable for this chapter) — chapter "monitor".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_MONITOR: NodeDef = {
  "id": "monitor",
  "tagKey": "path:monitor.tag",
  "x": 320,
  "y": 980,
  "w": 220,
  "h": 116,
  "titleKey": "path:monitor.title",
  "subKey": "path:monitor.sub",
  "blocks": [
    {
      "id": "monitor.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:monitor.b1.title",
      "bodyKey": "path:monitor.b1.body",
      "flowKey": "path:monitor.b1.flow",
      "read": [
        "sre"
      ]
    },
    {
      "id": "monitor.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:monitor.b2.title",
      "film": "f-monitor"
    },
    {
      "id": "monitor.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:monitor.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:monitor.b3o.opts.0.n",
            "wKey": "path:monitor.b3o.opts.0.w",
            "uKey": "path:monitor.b3o.opts.0.u",
            "cKey": "path:monitor.b3o.opts.0.c",
            "slug": "dashboard"
          },
          {
            "nKey": "path:monitor.b3o.opts.1.n",
            "wKey": "path:monitor.b3o.opts.1.w",
            "uKey": "path:monitor.b3o.opts.1.u",
            "cKey": "path:monitor.b3o.opts.1.c",
            "slug": "slo-burn-alerts"
          },
          {
            "nKey": "path:monitor.b3o.opts.2.n",
            "wKey": "path:monitor.b3o.opts.2.w",
            "uKey": "path:monitor.b3o.opts.2.u",
            "cKey": "path:monitor.b3o.opts.2.c",
            "slug": "log-search"
          },
          {
            "nKey": "path:monitor.b3o.opts.3.n",
            "wKey": "path:monitor.b3o.opts.3.w",
            "uKey": "path:monitor.b3o.opts.3.u",
            "cKey": "path:monitor.b3o.opts.3.c",
            "slug": "tracing-across-the-bus"
          },
          {
            "nKey": "path:monitor.b3o.opts.4.n",
            "wKey": "path:monitor.b3o.opts.4.w",
            "uKey": "path:monitor.b3o.opts.4.u",
            "cKey": "path:monitor.b3o.opts.4.c",
            "slug": "error-budget-policy"
          }
        ],
        "ref": "sre"
      }
    },
    {
      "id": "monitor.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:monitor.b3.title",
      "math": {
        "exprKey": "path:monitor.b3.math.expr",
        "readKey": "path:monitor.b3.math.read",
        "useKey": "path:monitor.b3.math.use",
        "ref": "sre"
      }
    },
    {
      "id": "monitor.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:monitor.b4.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:monitor.b4.ex.options.0.t",
            "ok": true,
            "fbKey": "path:monitor.b4.ex.options.0.fb"
          },
          {
            "tKey": "path:monitor.b4.ex.options.1.t",
            "ok": false,
            "fbKey": "path:monitor.b4.ex.options.1.fb"
          },
          {
            "tKey": "path:monitor.b4.ex.options.2.t",
            "ok": false,
            "fbKey": "path:monitor.b4.ex.options.2.fb"
          },
          {
            "tKey": "path:monitor.b4.ex.options.3.t",
            "ok": false,
            "fbKey": "path:monitor.b4.ex.options.3.fb"
          }
        ]
      }
    }
  ]
};